import { NavLink as RouterNavLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { ElementType, MouseEventHandler, ReactNode } from 'react';

interface NavLinkProps {
    href?: string;
    icon: ElementType;
    onClick?: MouseEventHandler; // TODO: change
    target?: string;
    children: ReactNode;
}

export default function NavLink({
    href = '#',
    icon: Icon,
    onClick,
    target,
    children,
}: NavLinkProps) {
    const { pathname } = useLocation();

    return (
        <li onClick={onClick}>
            <RouterNavLink
                to={href}
                end={
                    // Standalone categories
                    pathname === '/cviceni/lekce/pojd-se-seznamit' ||
                    pathname === '/cviceni/lekce/na-kazdy-den'
                }
                target={target}
            >
                {({ isActive, isPending }) => (
                    <button
                        className={clsx(
                            'flex w-full items-center rounded-xl py-[10px] pl-4 pr-3',
                            'transition-colors', // TODO: timing from active and to active seems a little bit odd
                            (isActive || isPending) && href !== '#'
                                ? 'bg-product-500 text-white'
                                : 'text-ink-900 hover:bg-cloud-200'
                        )}
                    >
                        <Icon size={20} className={clsx('mr-3 shrink-0')} />
                        <span className="text-left">{children}</span>
                    </button>
                )}
            </RouterNavLink>
        </li>
    );
}
